export default "__VITE_ASSET__DcHZanhM__"